import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.join.js";
import React, { useMemo } from 'react';
import { Route, Switch, generatePath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { slicePathSegments } from 'utils/ui';
import Card from 'components/Card';
import PageTitle from 'components/PageTitle';
import Stack from 'components/Stack';
import UnsavedChangesPrompt from 'components/UnsavedChangesPrompt';
import { PlaylistManageContentEditor } from './Editor';
import { PlaylistManageContentPreview } from './Preview';
import { StickyFooter } from './StickyFooter';
import { getContentAsTree } from './Editor/utils';
import { checkWasPlaylistStructureChanged } from './Editor/utils/checkWasPlaylistStructureChanged';
import PageBackLink from 'components/PageBackLink';
export var MANAGE_CONTENT_ROUTES = {
  root: '/playlists/:playlistId/manage-content',
  preview: '/playlists/:playlistId/manage-content/preview'
};
function PlaylistManageContentScreen(_ref) {
  var initialPlaylistData = _ref.initialPlaylistData,
    reducerState = _ref.reducerState,
    _ref$stickyHeaderComp = _ref.stickyHeaderCompensation,
    stickyHeaderCompensation = _ref$stickyHeaderComp === void 0 ? true : _ref$stickyHeaderComp;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = initialPlaylistData.id,
    name = initialPlaylistData.name;
  var basePath = generatePath(MANAGE_CONTENT_ROUTES.root, {
    playlistId: id
  });
  var previewPath = generatePath(MANAGE_CONTENT_ROUTES.preview, {
    playlistId: id
  });
  var playlistLink = slicePathSegments(basePath, 0, -1);
  var _reducerState = _slicedToArray(reducerState, 3),
    content = _reducerState[0].content,
    history = _reducerState[2];
  var initialContent = history.initial.content;
  var contentAsTree = useMemo(function () {
    return getContentAsTree(content);
  }, [content]);
  var initialContentAsTree = useMemo(function () {
    return getContentAsTree(initialContent);
  }, [initialContent]);
  var hasPlaylistChanges = useMemo(function () {
    var hasContentChanges = content.some(function (item) {
      return item.changedFields.size > 0;
    });
    if (hasContentChanges) {
      return true;
    }
    return checkWasPlaylistStructureChanged(contentAsTree, initialContentAsTree);
  }, [content, contentAsTree, initialContentAsTree]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasPlaylistChanges,
    permissablePaths: [basePath, previewPath]
  }), /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(Card, {
    px: ['s', 'm', 'l'],
    py: ['s', 'm'],
    breakpoints: ['xs', 's']
  }, /*#__PURE__*/React.createElement(PageBackLink, {
    to: playlistLink,
    mb: "xs"
  }, t('actions_back_to_playlist')), /*#__PURE__*/React.createElement(PageTitle, {
    size: "large",
    text: [t('actions_manage_content'), name].join(' - ')
  }, name)), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: MANAGE_CONTENT_ROUTES.root,
    render: function render() {
      return /*#__PURE__*/React.createElement(PlaylistManageContentEditor, {
        stickyHeaderCompensation: stickyHeaderCompensation,
        reducerState: reducerState,
        contentAsTree: contentAsTree,
        playlist: initialPlaylistData
      });
    }
  }), /*#__PURE__*/React.createElement(Route, {
    path: MANAGE_CONTENT_ROUTES.preview,
    render: function render() {
      return /*#__PURE__*/React.createElement(PlaylistManageContentPreview, {
        initialPlaylistData: initialPlaylistData,
        reducerState: reducerState
      });
    }
  }))), /*#__PURE__*/React.createElement(StickyFooter, {
    reducerState: reducerState,
    hasPlaylistChanges: hasPlaylistChanges,
    initialPlaylistData: initialPlaylistData
  }));
}
export { usePlaylistManageContentState } from './usePlaylistManageContentState';
export { formatContentForEditor } from './Editor/utils/formatContentForEditor';
export default PlaylistManageContentScreen;